export default [
    {
        name: 'Monday',
        value: 1,
    },
    {
        name: 'Tuesday',
        value: 2,
    },
    {
        name: 'Wednesday',
        value: 3,
    },
    {
        name: 'Thursday',
        value: 4,
    },
    {
        name: 'Friday',
        value: 5
    },
    {
        name: 'Saturday',
        value: 6
    },
    {
        name: 'Sunday',
        value: 7
    }
]